// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emoji-picker-react input.emoji-search {\n    width: calc(100% - 30px);\n    margin-left: 15px;\n    outline: none;\n    box-shadow: none;\n    padding: 10px;\n    box-sizing: border-box;\n    border: 1px solid #efefef;\n    border-radius: 3px;\n    transition: border .1s;\n}\n\n.emoji-picker-react input.emoji-search:focus {\n    border: 1px solid #D6D6D6;\n}\n", ""]);
// Exports
module.exports = exports;
